import { style } from '@vanilla-extract/css';

export const container = style({
  alignItems: 'center',
  borderRadius: '8px',
  overflow: 'hidden',
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  fontSize: '0.875rem',
  fontWeight: 500,
  padding: '2rem',
});

export const textCenter = style({
  textAlign: 'center',
});

export const logo = style({
  height: '56px',
  width: '56px',
  margin: '0 auto 1rem',
  display: 'block',
});

export const title = style({
  fontWeight: 600,
  margin: '0.5rem 0 0.75rem',
});

export const description = style({
  marginTop: 0,
  color: 'var(--paywall-text-color)',
});

export const button = style({
  margin: '28px 0',
  textDecoration: 'none',
  lineHeight: 1.2,
  padding: '0 14px',
  height: '42px',
  display: 'inline-flex',
  alignItems: 'center',
});

export const subheader = style({
  margin: '0px',
  fontWeight: 600,
});

export const featureList = style({
  marginTop: '12px',
  listStyleType: 'none',
  padding: 0,
});

export const featureListItem = style({
  display: 'flex',
  alignItems: 'center',
  color: 'var(--paywall-text-color)',
  position: 'relative',
  padding: '6px 0',
  paddingLeft: '1rem',
  '::before': {
    content: '"•"',
    position: 'absolute',
    left: 0,
  },
});
